let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hQDxa")).then(() => parcelRequire('7FBZw'));